import { Switch } from "@babackapp/ui/components/switch";
import { forwardRef } from "react";
import FormInputContainer from "./form-input-container";

type FormSwitchProps = {
  label: string;
  description?: string;
  disabled?: string | boolean;
  value: boolean;
  onChange: (value: boolean) => void;
};

const FormSwitch = forwardRef(
  ({ label, description, disabled, ...props }: FormSwitchProps, ref) => {
    void ref;
    return (
      <FormInputContainer
        label={label}
        description={description}
        disabled={disabled}
        direction="horizontal"
      >
        <Switch
          className={disabled ? "pointer-events-none cursor-not-allowed" : ""}
          checked={props.value}
          onCheckedChange={disabled ? undefined : props.onChange}
        />
      </FormInputContainer>
    );
  },
);

FormSwitch.displayName = "FormSwitch";

export default FormSwitch;
